import { ConfigTreeNode } from '../models';

export function getRootConfigKey(configTree: Map<string, ConfigTreeNode>): string {
  for (const [key, value] of Array.from(configTree.entries())) {
    if (value.parent == null) {
      return key;
    }
  }
  throw Error('Could not find root config');
}
